import React, { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import {
  Layout,
  Button,
  Row,
  Col,
  Dropdown,
  Space,
  Divider,
  Table,
  Select,
  Input,
  Form,
  DatePicker,
  MenuProps,
  Modal,
  Image,
  Card,
} from "antd";
import {
  PlusOutlined,
  CheckOutlined,
  EditOutlined,
  SaveOutlined,
  MoreOutlined,
  DeleteOutlined,
  UserAddOutlined,
  BorderOutlined,
  ArrowRightOutlined,
  EllipsisOutlined,
} from "@ant-design/icons";
import "./ShipmentForm.css";
import MaterialForm from "../MaterialForm/MaterialForm";
import moment from "moment";
import TextArea from "antd/es/input/TextArea";
import BundleShipmentForm from "../BundleShipmentForm/BundleShipmentForm";
import SelectShipmentForm from "../SelectShipmentForm/SelectShipmentForm";

export interface ShipmentFormProps {
  scaleSerialPort: any;
  recordMaterial: () => any;
  captureScaleImage: () => any;
  captureMaterialImage: () => any;
  postAddToShipment: (materialInfo: any) => void;
  putMaterial: (materialInfo: any) => any;
  postCompleteShipment: (materialsList: any[], notes: string, totalNetWeight: Number, totalNumMaterials: Number) => any;
  getShipment: (shipmentIDFromURL: string) => any;
  getMaterial: (materialID: string) => any;
  updateLoading: (loading: boolean) => void;
  resetNewShipmentPage: () => void;
  deleteMaterial: (materialID: string) => void;
  getMetals: () => any;
  getCategories: () => any;
  resetImageView: () => void;
  getBundles: () => any;
  addBundlesToShipment: (bundleIDs: String[]) => void;
  scaleImageSrc: string;
  materialImageSrc: string;
  showSelectShipmentForm: boolean;
  postShipmentSelected: (
    selectedDate: string,
    lorryNumberPlate: string,
    lorryDriver: string,
    shipmentDirection: string
  ) => void;
  getSelectedShipmentInfo: (data: any) => void;
  selectedShipmentInfo: any;
}

const ShipmentForm = (props: ShipmentFormProps) => {
  // const [loadedShipment, setLoadedShipment] = useState({}) as any;
  const [materialsList, setMaterialsList] = useState([]) as any;
  const [materialsListTotalNetWeight, setMaterialsListTotalNetWeight] = useState(0.0) as any;
  const [showMaterialForm, setShowMaterialForm] = useState(false);
  const [showBundleForm, setShowBundleForm] = useState(false);
  const [shipmentStarted, setshipmentStarted] = useState(false);
  const [shipmentValid, setShipmentValid] = useState(false);
  const [shipmentIDFromURL, setShipmentIDFromURL] = useState("");
  const [editMaterialData, setEditMaterialData] = useState(null) as any;
  const [tableFormMessage, setTableFormMessage] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [dateSelectedFormStatus, setDateSelectedFormStatus] = useState("") as any;
  const [dateSelectedFormMessage, setDateSelectedFormMessage] = useState("");
  const [isDateChanged, setIsDateChanged] = useState(false);
  const [ableToEditShipment, setAbleToEditShipment] = useState(true);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [materialToDelete, setMaterialToDelete] = useState({}) as any;
  const [metals, setMetals] = useState([]);
  const [categories, setCategories] = useState([]);
  const [notes, setNotes] = useState("");
  const location = useLocation();
  const [totalNetWeight, setTotalNetWeight] = useState(0.0) as any;
  const [totalNumMaterials, setTotalNumMaterials] = useState(0) as any;
  const [showSummaryView, setShowSummaryView] = useState(false);

  const newShipmentColumns = [
    {
      title: "Item Number",
      key: "index",
      render: (text: any, record: any, index: any) => index + 1,
      align: "center" as const,
    },
    {
      title: "Image",
      key: "index",
      render: (record: any) => {
        return (
          <>
            <Image
              height={50}
              width={50}
              src={record.scaleImageSrc || record.scaleImageURL || record.originScaleImageURL || record.originImageURL}
              wrapperStyle={{ marginRight: "10px" }}
              preview={{
                toolbarRender: () => (
                  <>
                    <h1 style={{ color: "#000000" }}>{record.displayName}</h1>
                    <h3 style={{ color: "#000000" }}>Raw Weight: {Number(record.rawWeight).toFixed(1)} kg</h3>
                  </>
                ),
              }}
            />
            <Image
              height={50}
              width={50}
              src={record.materialImageSrc || record.materialImageURL || record.originMaterialImageURL}
              preview={{
                toolbarRender: () => (
                  <>
                    <h1 style={{ color: "#000000" }}>{record.displayName}</h1>
                    <h3 style={{ color: "#000000" }}>Raw Weight: {Number(record.rawWeight).toFixed(1)} kg</h3>
                  </>
                ),
              }}
            />
          </>
        );
      },
      align: "center" as const,
    },
    {
      title: "Material Name",
      key: "materialName",
      dataIndex: "displayName",
      align: "left" as const,
      render: (record: any) => record,
    },
    {
      title: "Package Type",
      key: "packageType",
      dataIndex: "packageType",
      align: "left" as const,
      render: (record: any) => record,
    },
    {
      title: "Raw Weight (kg)",
      key: "rawWeight",
      dataIndex: "rawWeight",
      align: "center" as const,
      render: (record: any) => Number(record).toFixed(1),
    },
    {
      title: "Waste Weight (kg)",
      key: "wasteWeight",
      align: "center" as const,
      render: (record: any) => {
        let wasteInfo = "(";
        if (record.smallBag > 0) {
          if (record.bigBag > 0) wasteInfo += `${record.smallBag} small, `;
          else wasteInfo += `${record.smallBag} small`;
        }
        if (record.bigBag > 0) {
          if (record.jumboBag > 0) wasteInfo += `${record.bigBag} big, `;
          else wasteInfo += `${record.bigBag} big`;
        }
        if (record.jumboBag > 0) {
          wasteInfo += `${record.jumboBag} jumbo`;
        }
        wasteInfo += ")";
        return (
          <>
            <Row justify="center">
              {!isNewShipmentOrNotCompleted() ? (
                <Row justify="center">{Number(record.wasteWeight).toFixed(1)}</Row>
              ) : (
                <Input
                  placeholder="0.0"
                  style={{
                    width: "150px",
                    marginBottom: "10px",
                    marginRight: "5px",
                    textAlign: "center",
                  }}
                  value={record.wasteWeight}
                  onClick={(e) =>
                    e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)
                  }
                  onChange={(e) => updateWasteWeight(record, e.target.value)}
                />
              )}
            </Row>

            {(record.smallBag > 0 || record.bigBag > 0 || record.jumboBag > 0) && (
              <Row justify="center" style={{ fontSize: "12px" }}>
                {wasteInfo}
              </Row>
            )}
            {record.other && (
              <Row justify="center" style={{ fontSize: "12px" }}>
                ( Other: {record.other})
              </Row>
            )}
          </>
        );
      },
    },
    {
      title: "Net Weight (kg)",
      key: "netWeight",
      dataIndex: "netWeight",
      align: "center" as const,
      render: (record: any) => Number(record).toFixed(1),
    },
    {
      title: "Manual Entry",
      key: "manualEntry",
      align: "center" as const,
      render: (record: any) => {
        let entry = "Yes";
        if (record.manualEntry !== undefined) {
          entry = record.manualEntry ? "Yes" : "No";
        } else if (record.originManualEntry !== undefined) {
          entry = record.originManualEntry ? "Yes" : "No";
        }
        return entry;
      },
    },
    {
      title: "",
      key: "editMaterial",
      align: "center" as const,
      render: (record: any) =>
        record.updateWasteWeight ? (
          <Button
            type="primary"
            icon={<SaveOutlined />}
            onClick={() => {
              saveWasteWeight(record);
            }}
          >
            Save
          </Button>
        ) : null,
    },
    {
      title: "",
      key: "options",
      align: "center" as const,
      width: "7.5%",
      render: (record: any) => {
        const items: MenuProps["items"] = [
          { key: "edit", label: "Edit Material", icon: <EditOutlined disabled={!ableToAddMaterials()} /> },
          { key: "delete", label: "Delete Material", icon: <DeleteOutlined />, style: { color: "red" } },
        ];
        return ableToAddMaterials() ? (
          <Dropdown
            menu={{
              items,
              onClick: ({ key }) => {
                if (key === "edit") {
                  openMaterialForm();
                  setEditMaterialData({
                    materialID: record.materialID,
                    name: record.name,
                    rawWeight: record.rawWeight,
                    wasteWeight: record.wasteWeight,
                    netWeight: record.netWeight,
                    manualEntry: record.manualEntry,
                    smallBag: record.smallBag,
                    bigBag: record.bigBag,
                    jumboBag: record.jumboBag,
                    other: record.other,
                    displayName: record.displayName,
                    metalID: record.metalID,
                    notes: record.notes,
                  });
                } else if (key === "delete") {
                  openDeleteShipmentModal(record);
                }
              },
            }}
            trigger={["click"]}
          >
            <a onClick={(e) => e.preventDefault()}>
              <MoreOutlined style={{ fontSize: "24px" }} />
            </a>
          </Dropdown>
        ) : (
          <></>
        );
      },
    },
  ];

  useEffect(() => {
    getMetalsShipmentForm();
  }, []);

  useEffect(() => {
    const IDFromURL = location.pathname.split("/")[2];
    // getMetalsShipmentForm();
    if (IDFromURL !== undefined) {
      setShipmentIDFromURL(IDFromURL);
      loadShipmentInfo(IDFromURL);
    } else resetShipmentInfo();
  }, [shipmentIDFromURL, location.pathname, metals]);

  const isNewShipmentOrNotCompleted = () => {
    return location.pathname.split("/")[2] === undefined || !props.selectedShipmentInfo.completed;
  };

  const updateShipmentDate = (dateString: string) => {
    setDateSelectedFormStatus("");
    setDateSelectedFormMessage("");
    setSelectedDate(dateString);
  };

  const items: MenuProps["items"] = [
    { key: "edit", label: "Edit Material", icon: <EditOutlined disabled={!isNewShipmentOrNotCompleted()} /> },
    { key: "delete", label: "Delete Material", icon: <DeleteOutlined />, style: { color: "red" } },
  ];

  const isTimestampMoreThan2Hours = () => {
    if (props.selectedShipmentInfo.createdTimestamp !== undefined) {
      const createdMilliseconds = new Date(props.selectedShipmentInfo.createdTimestamp).getTime();
      const currentTimeMilliseconds = new Date().getTime();
      return currentTimeMilliseconds - createdMilliseconds > 7776000000 ? true : false;
    }
    return false;
  };

  const validateForm = () => {
    let validationFormStatus = true;
    materialsList.forEach((material: any) => {
      if (material.updateWasteWeight) validationFormStatus = false;
    });
    if (!validationFormStatus) setTableFormMessage("Save all changes for waste weight");
    return validationFormStatus;
  };

  const openDeleteShipmentModal = (record: any) => {
    setMaterialToDelete(record);
    setIsDeleteModalOpen(true);
  };

  const confirmDeleteMaterialFromShipment = () => {
    props.deleteMaterial(materialToDelete.materialID);
    //check if deleted from status
    let currMaterialsList = [...materialsList];
    currMaterialsList = currMaterialsList.filter(
      (material: any) => material.materialID !== materialToDelete.materialID
    );
    calcNumMaterials(currMaterialsList);
    calcTotalNetWeight(currMaterialsList);
    setMaterialsList(currMaterialsList);
    setIsDeleteModalOpen(false);
  };

  const declineDeleteMaterialFromShipment = () => {
    setMaterialToDelete({});
    setIsDeleteModalOpen(false);
  };

  const saveWasteWeight = async (record: any) => {
    await props.putMaterial(record);
    const materials = [...materialsList];
    const material = materials.find((material: any) => material.materialID === record.materialID);
    material.updateWasteWeight = false;
    setTableFormMessage("");
    setMaterialsList(materials);
  };

  const updateWasteWeight = (record: any, wasteWeight: string) => {
    setTableFormMessage("");
    const materials = [...materialsList];
    const material = materials.find((material: any) => material.materialID === record.materialID);
    material.wasteWeight = wasteWeight;
    material.updateWasteWeight = true;
    material.netWeight = Number(material.rawWeight) - Number(wasteWeight);
    setMaterialsList(materials);
  };

  const getMetalsShipmentForm = async () => {
    const data = await props.getMetals();
    setMetals(data);
  };

  const resetShipmentInfo = () => {
    setShipmentIDFromURL("");
    setshipmentStarted(false);
    setShipmentValid(false);
    setMaterialsList([]);
    props.resetNewShipmentPage();
  };

  const resetEditMaterialData = () => {
    setEditMaterialData(null);
  };

  const loadShipmentInfo = async (shipmentIDFromURL: string) => {
    props.updateLoading(true);
    const shipmentInfo: any = await props.getShipment(shipmentIDFromURL);
    props.getSelectedShipmentInfo(shipmentInfo);
    // setprops.selectedShipmentInfo(shipmentInfo);
    setshipmentStarted(true);
    setShipmentValid(true);
    setNotes(shipmentInfo.notes);
    let currMaterials: any[] = [];
    for (let materialID of shipmentInfo.materialIDList) {
      const resMaterial = await props.getMaterial(materialID);
      const currMetal: any = metals.find((metal: any) => metal.metalID === resMaterial.metalID);
      resMaterial.key = resMaterial.materialID;
      resMaterial.displayName = currMetal ? currMetal.displayName : "";
      //temp fix for now
      resMaterial.rawWeight = resMaterial.originRawWeight;
      resMaterial.wasteWeight = resMaterial.originWasteWeight;
      resMaterial.netWeight = resMaterial.originNetWeight;
      resMaterial.smallBag = resMaterial.originSmallBag;
      resMaterial.bigBag = resMaterial.originBigBag;
      resMaterial.jumboBag = resMaterial.originJumboBag;
      resMaterial.imageURL = resMaterial.originImageURL;
      //temp fix for now
      currMaterials.push(resMaterial);
    }
    // currMaterials.sort((a, b) => a.displayName.localeCompare(b.displayName));
    setMaterialsList(currMaterials);
    calcNumMaterials(currMaterials);
    calcTotalNetWeight(currMaterials);
    isAbleToEditShipment(shipmentInfo.completed);
    props.updateLoading(false);
  };

  const isAbleToEditShipment = (completed: boolean) => {
    setAbleToEditShipment(completed);
  };

  const openMaterialForm = () => {
    setShowMaterialForm(true);
  };

  const closeMaterialForm = () => {
    setShowMaterialForm(false);
  };

  const openBundleForm = () => {
    setShowBundleForm(true);
  };

  const closeBundleForm = () => {
    setShowBundleForm(false);
  };

  const completeShipment = () => {
    props.postCompleteShipment(materialsList, notes, totalNetWeight, totalNumMaterials);
  };

  const addToMaterialsList = async (materialInfo: any) => {
    let materials = [...materialsList];
    let totalNetWeight = Number((Number(materialsListTotalNetWeight) + Number(materialInfo.netWeight)).toFixed(1));
    //calculateTotalNetWeight()
    setMaterialsListTotalNetWeight(totalNetWeight);
    materialInfo.scaleImageSrc = props.scaleImageSrc;
    materialInfo.key = materialInfo.materialID;
    materialInfo.displayName = materialInfo.displayName;
    const resData: any = await props.postAddToShipment(materialInfo);
    materials.push(materialInfo);
    // materials.sort((a, b) => a.displayName.localeCompare(b.displayName));
    setMaterialsList(materials);
    isShipmentValid(materials);
    calcNumMaterials(materials);
    calcTotalNetWeight(materials);
    closeMaterialForm();
  };

  const saveToMaterialsList = async (materialInfo: any) => {
    let materials = [...materialsList];
    materials.forEach((material: any) => {
      if (material.materialID === materialInfo.materialID) {
        material.name = materialInfo.name;
        material.displayName = materialInfo.displayName;
        material.metalID = materialInfo.metalID;
        material.rawWeight = materialInfo.rawWeight;
        material.wasteWeight = materialInfo.wasteWeight;
        material.netWeight = materialInfo.netWeight;
        material.manualEntry = materialInfo.manualEntry;
        material.smallBag = materialInfo.smallBag;
        material.bigBag = materialInfo.bigBag;
        material.jumboBag = materialInfo.jumboBag;
        material.notes = materialInfo.notes;
        material.scaleImageSrc = props.scaleImageSrc;
      }
    });
    isShipmentValid(materials);
    const res = await props.putMaterial(materialInfo);
    setMaterialsList([...materials]);
    calcNumMaterials(materials);
    calcTotalNetWeight(materials);
    closeMaterialForm();
  };

  const isShipmentValid = (materials: any) => {
    setShipmentValid(materials.length > 0);
  };

  const isshipmentStarted = () => {
    return shipmentStarted;
  };

  const updateSetIsDateChanged = () => {
    setIsDateChanged(true);
  };

  const getUpdatedDate = () => {
    const dateProperties = selectedDate.split("/");
    return new Date(`${dateProperties[2]}-${dateProperties[1]}-${dateProperties[0]}`).toLocaleDateString("en-GB");
  };

  const ableToAddMaterials = () => {
    // return (!isTimestampMoreThan2Hours() || isNewShipmentOrNotCompleted()) && isshipmentStarted();
    return !isTimestampMoreThan2Hours() || isNewShipmentOrNotCompleted();
  };

  const updateNotes = (text: string) => {
    setNotes(text);
  };

  const displayShipmentDirection = () => {
    let officeNameFormat: any = {
      pg: "Penang (PG)",
      bw: "Butterworth (BW)",
    };
    return (
      <h3>
        <div style={{ display: "flex" }}>
          <div>Direction: </div>
          <div className={`${props.selectedShipmentInfo.origin}-square-icon`}></div>
          <div> {officeNameFormat[props.selectedShipmentInfo.origin]}</div>
          <ArrowRightOutlined style={{ margin: "0 5px" }} />
          <div className={`${props.selectedShipmentInfo.dest}-square-icon`}></div>
          {officeNameFormat[props.selectedShipmentInfo.dest]}
        </div>
      </h3>
    );
  };

  // const openSummaryView = () => {
  //   setShowSummaryView(true);
  // };

  // const closeSummaryView = () => {
  //   setShowSummaryView(false);
  // };

  const getBagInfo = (material: any) => {
    let bagInfo = "(";
    if (material.smallBag > 0) {
      if (material.bigBag > 0) bagInfo += `${material.smallBag}S,`;
      else bagInfo += `${material.smallBag}S`;
    }
    if (material.bigBag > 0) {
      if (material.jumboBag > 0) bagInfo += `${material.bigBag}B,`;
      else bagInfo += `${material.bigBag}B`;
    }
    if (material.jumboBag > 0) {
      bagInfo += `${material.jumboBag}J`;
    }
    bagInfo += ")";
    if (material.smallBag == 0 && material.bigBag == 0 && material.jumboBag == 0) bagInfo = "";
    return bagInfo;
  };

  const isScaleImageVisible = (material: any) => {
    return (
      (material.scaleImageSrc !== undefined && material.scaleImageSrc !== "" && material.scaleImageSrc !== null) ||
      (material.scaleImageURL !== undefined && material.scaleImageURL !== "" && material.scaleImageURL !== null)
    );
  };

  const isMaterialImageVisible = (material: any) => {
    return (
      (material.materialImageSrc !== undefined &&
        material.materialImageSrc !== "" &&
        material.materialImageSrc !== null) ||
      (material.materialImageURL !== undefined &&
        material.materialImageURL !== "" &&
        material.materialImageURL !== null)
    );
  };

  const calcNumMaterials = (materials: any[]) => {
    let currMetals: string[] = [];
    let currNumMaterials = 0;
    materials.forEach((material: any) => {
      if (!currMetals.includes(material.metalID)) {
        currMetals.push(material.metalID);
        currNumMaterials += 1;
      }
    });
    setTotalNumMaterials(currNumMaterials);
  };

  const calcTotalNetWeight = (materials: any[]) => {
    let totalNetWeight = 0.0;
    materials.forEach((material: any) => {
      totalNetWeight = Number(totalNetWeight) + Number(material.netWeight);
    });
    setTotalNetWeight(Number(totalNetWeight).toFixed(1));
  };

  return (
    <div className="shipment-form-container">
      <Row>
        <Col span={12}>
          <Row justify="start">
            <h2>Shipment</h2>
          </Row>
        </Col>
        <Col span={12}>
          <Row justify="end">
            {isNewShipmentOrNotCompleted() ? (
              isDateChanged ? (
                <Form layout="vertical">
                  <Form.Item validateStatus={dateSelectedFormStatus} help={dateSelectedFormMessage}>
                    <DatePicker
                      allowClear={false}
                      onChange={(date, dateString) => updateShipmentDate(dateString)}
                      format={"DD/MM/YYYY"}
                      showToday
                      disabledDate={(current) => {
                        let customDate = moment().add(1, "day").format("YYYY-MM-DD");
                        return current && current > moment(customDate, "YYYY-MM-DD");
                      }}
                    />
                  </Form.Item>
                </Form>
              ) : (
                <>
                  {props.selectedShipmentInfo.createdTimestamp !== undefined ? (
                    <h2>{new Date(props.selectedShipmentInfo.createdTimestamp).toLocaleDateString("en-GB")}</h2>
                  ) : selectedDate !== "" ? (
                    <h2>{getUpdatedDate()}</h2>
                  ) : (
                    <h2>{new Date().toLocaleDateString("en-GB")}</h2>
                  )}
                  <Button
                    type="default"
                    onClick={() => updateSetIsDateChanged()}
                    icon={<EditOutlined />}
                    style={{ marginLeft: "10px" }}
                    disabled={shipmentStarted}
                  ></Button>
                </>
              )
            ) : (
              <h2>{new Date(props.selectedShipmentInfo.createdTimestamp).toLocaleDateString("en-GB")}</h2>
            )}
          </Row>
        </Col>
      </Row>
      <Row>
        <Divider style={{ margin: "12px 0" }} />
      </Row>
      <Row>
        <Col span={24}>
          <Row justify="start">
            <h3>Shipment Information</h3>
          </Row>
        </Col>
      </Row>
      <Row className="shipment-dropdown-container">
        <Col span={12}>
          <h3>Lorry Number Plate: {props.selectedShipmentInfo.lorryNumberPlate}</h3>
          {displayShipmentDirection()}
        </Col>
        <Col span={12}>
          <Row justify="end">
            <h3>Lorry Driver: {props.selectedShipmentInfo.driver}</h3>
          </Row>
        </Col>
      </Row>
      <Row>
        <Divider style={{ margin: "12px 0" }} />
      </Row>
      <Row>
        <Col span={8}>
          <Row justify="start">
            <h3>
              {totalNumMaterials} Materials ({materialsList.length} Weights)
            </h3>
          </Row>
        </Col>
        <Col span={8}>
          <Row justify="center">
            <h3>Total Net Weight: {Number(totalNetWeight).toFixed(1)} kg</h3>
          </Row>
        </Col>
        {/* <Col span={8}>
          <Row justify="end">
            <Button type="default" onClick={openSummaryView}>
              Shipment Summary
            </Button>
          </Row>
        </Col> */}
      </Row>
      <Row justify="start" className="materials-table">
        <Col span={24}>
          <Row justify="start">
            <Col span={4}>
              <Card className="materials-card" bodyStyle={{ padding: 0 }}>
                <Row justify="center" align="middle" style={{ height: "250px" }}>
                  <Button
                    type="primary"
                    className="add-materials-button"
                    onClick={openMaterialForm}
                    disabled={!ableToAddMaterials()}
                  >
                    <PlusOutlined style={{ fontSize: 30 }} />
                    <Row>Add Material</Row>
                  </Button>
                </Row>
              </Card>
            </Col>
            {materialsList.map((material: any, index: number) => {
              return (
                <Col span={4}>
                  <Card className="materials-card" bodyStyle={{ padding: 0 }}>
                    <Row style={{ height: "250px" }}>
                      <Col span={24}>
                        <Row justify="start">
                          <Col span={20}>
                            <h3>
                              <b>
                                {index + 1}. {material.displayName}
                              </b>
                            </h3>
                          </Col>
                          <Col span={4}>
                            <Row justify="end">
                              <Dropdown
                                menu={{
                                  items,
                                  onClick: ({ key }) => {
                                    if (key === "edit") {
                                      openMaterialForm();
                                      setEditMaterialData({
                                        materialID: material.materialID,
                                        name: material.name,
                                        rawWeight: material.rawWeight,
                                        wasteWeight: material.wasteWeight,
                                        netWeight: material.netWeight,
                                        manualEntry: material.manualEntry,
                                        smallBag: material.smallBag,
                                        bigBag: material.bigBag,
                                        jumboBag: material.jumboBag,
                                        other: material.other,
                                        displayName: material.displayName,
                                        metalID: material.metalID,
                                        notes: material.notes,
                                        scaleImageSrc: material.scaleImageSrc,
                                        materialImageSrc: material.materialImageSrc,
                                      });
                                    } else if (key === "delete") {
                                      openDeleteShipmentModal(material);
                                    }
                                  },
                                }}
                                trigger={["click"]}
                              >
                                <a onClick={(e) => e.preventDefault()}>
                                  <EllipsisOutlined style={{ fontSize: "24px" }} />
                                </a>
                              </Dropdown>
                            </Row>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={5}>
                            <h3>Raw:</h3>
                          </Col>
                          <Col span={6}>
                            <Row justify="end">
                              <h3>{Number(material.rawWeight).toFixed(1)}</h3>
                            </Row>
                          </Col>
                          <Col span={3}>
                            <Row justify="end">
                              <h3>kg</h3>
                            </Row>
                          </Col>
                          <Col span={10}>
                            <Row justify="center">
                              <h3>{getBagInfo(material)}</h3>
                            </Row>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={ableToAddMaterials() ? 8 : 5}>
                            <h3>Waste:</h3>
                          </Col>
                          <Col span={ableToAddMaterials() ? 9 : 6}>
                            <Row justify="end">
                              {ableToAddMaterials() ? (
                                <Input
                                  placeholder="0.0"
                                  style={{
                                    textAlign: "center",
                                  }}
                                  value={material.wasteWeight}
                                  onChange={(e) => updateWasteWeight(material, e.target.value)}
                                />
                              ) : (
                                <h3>{Number(material.wasteWeight).toFixed(1)}</h3>
                              )}
                            </Row>
                          </Col>
                          <Col span={6}>
                            <Row justify={ableToAddMaterials() ? "start" : "end"}>
                              <h3>kg (-)</h3>
                            </Row>
                          </Col>
                        </Row>
                        <Row>
                          <Divider style={{ margin: "5px 0", backgroundColor: "black" }} />
                        </Row>
                        <Row>
                          <Col span={5}>
                            <h3>
                              <b>Net:</b>
                            </h3>
                          </Col>
                          <Col span={6}>
                            <Row justify="end">
                              <h3>
                                <b>{Number(material.netWeight).toFixed(1)}</b>
                              </h3>
                            </Row>
                          </Col>
                          <Col span={3}>
                            <Row justify="end">
                              <h3>
                                <b>kg</b>
                              </h3>
                            </Row>
                          </Col>
                        </Row>
                        <Row>
                          {isScaleImageVisible(material) && (
                            <Col span={12}>
                              <Row justify="center">
                                <Image
                                  height={60}
                                  width={70}
                                  src={material.scaleImageSrc || material.scaleImageURL}
                                  preview={{
                                    toolbarRender: () => (
                                      <>
                                        <h1 style={{ color: "#000000" }}>{material.displayName}</h1>
                                        <h3 style={{ color: "#000000" }}>
                                          Raw Weight: {Number(material.rawWeight).toFixed(1)} kg
                                        </h3>
                                      </>
                                    ),
                                  }}
                                />
                              </Row>
                            </Col>
                          )}
                          {isMaterialImageVisible(material) && (
                            <Col span={12}>
                              <Row justify="center">
                                <Image
                                  height={60}
                                  width={70}
                                  src={material.materialImageSrc || material.materialImageURL}
                                  preview={{
                                    toolbarRender: () => (
                                      <>
                                        <h1 style={{ color: "#000000" }}>{material.displayName}</h1>
                                        <h3 style={{ color: "#000000" }}>
                                          Raw Weight: {Number(material.rawWeight).toFixed(1)} kg
                                        </h3>
                                      </>
                                    ),
                                  }}
                                />
                              </Row>
                            </Col>
                          )}
                        </Row>
                        {material.updateWasteWeight && (
                          <Row>
                            <Col span={24}>
                              <Button
                                type="primary"
                                className="save-material-button"
                                icon={<SaveOutlined />}
                                onClick={() => {
                                  saveWasteWeight(material);
                                }}
                              >
                                Save Waste Weight
                              </Button>
                            </Col>
                          </Row>
                        )}
                      </Col>
                    </Row>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </Col>
      </Row>
      <Row>
        <Divider style={{ margin: "12px 0" }} />
      </Row>
      <Row>
        <Col span={24}>
          <Row className="material-form-label" style={{ margin: "10px 0" }}>
            Notes
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={18}>
          <Row justify="start">
            <TextArea
              showCount
              style={{ height: 50 }}
              onChange={(e) => updateNotes(e.target.value)}
              placeholder="Enter shipment notes"
              value={notes}
            />
          </Row>
        </Col>
        <Col span={6}>
          <Row justify="end">
            <Button
              type="primary"
              icon={<CheckOutlined />}
              onClick={() => validateForm() && completeShipment()}
              disabled={materialsList.length < 1 || !ableToAddMaterials()}
              style={{ height: "50px", width: "90%" }}
            >
              Complete Shipment
            </Button>
          </Row>
          <Row justify="center" className="table-form-message">
            {tableFormMessage}
          </Row>
        </Col>
      </Row>
      {/* <Button
        type="default"
        className="add-materials-button"
        icon={<BorderOutlined />}
        onClick={openBundleForm}
        disabled={!ableToAddMaterials()}
      >
        Add Bundle
      </Button> */}
      {/* <Row justify="start" className="table-form-message">
        {tableFormMessage}
      </Row>
      <div className="shipment-out-button-div">
        {ableToAddMaterials() && (
          <Row justify="center">
            <Button
              type="primary"
              icon={<CheckOutlined />}
              onClick={() => validateForm() && completeShipment()}
              disabled={!shipmentValid}
            >
              Complete Shipment
            </Button>
          </Row>
        )}
        <Row className="material-form-label" style={{ margin: "10px 0" }}>
          Notes
        </Row>
        <Row>
          <TextArea
            showCount
            style={{ height: 50 }}
            onChange={(e) => updateNotes(e.target.value)}
            placeholder="Enter shipment notes"
            value={notes}
          />
        </Row>
      </div> */}
      <MaterialForm
        type="shipment"
        scaleSerialPort={props.scaleSerialPort}
        showForm={showMaterialForm}
        closeForm={closeMaterialForm}
        recordMaterial={props.recordMaterial}
        captureScaleImage={props.captureScaleImage}
        captureMaterialImage={props.captureMaterialImage}
        addToMaterialsList={addToMaterialsList}
        saveToMaterialsList={saveToMaterialsList}
        editMaterialData={editMaterialData}
        resetEditMaterialData={resetEditMaterialData}
        metals={metals}
        categories={categories}
        getMetalsForm={getMetalsShipmentForm}
        resetImageView={props.resetImageView}
        scaleImageSrc={props.scaleImageSrc}
        materialImageSrc={props.materialImageSrc}
      />
      <BundleShipmentForm
        showForm={showBundleForm}
        closeForm={closeBundleForm}
        addToMaterialsList={addToMaterialsList}
        editMaterialData={editMaterialData}
        resetEditMaterialData={resetEditMaterialData}
        metals={metals}
        getBundles={props.getBundles}
        addBundlesToShipment={props.addBundlesToShipment}
      />
      <SelectShipmentForm
        showForm={props.showSelectShipmentForm}
        postShipmentSelectedService={props.postShipmentSelected}
      />
      <Modal
        title="Delete Material"
        open={isDeleteModalOpen}
        okText="Confirm Delete"
        okType="danger"
        onOk={confirmDeleteMaterialFromShipment}
        onCancel={declineDeleteMaterialFromShipment}
      >
        <p>
          Are you sure you want to delete the material{" "}
          <strong>
            {materialToDelete.name} ({materialToDelete.netWeight} kg)
          </strong>{" "}
          from the shipment?
        </p>
        <p>This will permanently delete this material and this action cannot be undone.</p>
      </Modal>
    </div>
  );
};

export default ShipmentForm;
